import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { ErrorHandlingService } from './error-handling.service';
import { ModeService } from './mode.service';
import { SwalAlert } from '../helpers/alert';
import { InvoiceNoteDto } from '../dtos/invoice-note-dto.model';

@Injectable({
  providedIn: 'root'
})

export class InvoiceNotesService {
  invoiceNotesDto: InvoiceNoteDto | null = null;
  swalAlert = new SwalAlert();

  constructor(
    private readonly httpClient: HttpClient, 
    private readonly configService: ConfigService,
    private readonly modeService: ModeService,
    private readonly errorHandlingService: ErrorHandlingService) {
  }

  async getInvoiceNotes(orderId: number): Promise<InvoiceNoteDto> {
    return new Promise(resolve => {
      const waitingFor = 'Loading invoice notes';
      this.modeService.addToWaitList(waitingFor);
      this.httpClient.get<InvoiceNoteDto>(`${this.configService.apiUrl}/Order/GetInvoiceNotes/${orderId}`).subscribe({
        next: (data) => {
          this.modeService.removeFromWaitList(waitingFor);
          console.log(data);
          resolve(data);
        },
        error: e => {
          console.log(e);
          this.modeService.removeFromWaitList(waitingFor);
          alert(this.errorHandlingService.getErrorMessage(e));
          resolve(new InvoiceNoteDto);
        }
      });
    });
  }
}
